import * as React from 'react';
import { useEffect, useState } from 'react';
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from "react-icons/ai";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { setMyStatus, setOpen } from '../../Redux/Services/headerSlice';
import { CommonApiData, } from '../CommonComponents/EnvConfig';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { GetSession, RemoveSession, SetSession } from '../CommonComponents/cryptoUtils';

export const toggleFullScreen = (event, ID, setIsFullScreen, isFullScreen) => {
    if (!isFullScreen) {
        // Request full screen
        let element = document.documentElement;
        if (ID !== undefined && ID !== '') {
            element = document.getElementById(ID);
        }
        if (element) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
            element.style.overflow = 'auto';
            setIsFullScreen(true);
        }
    }
    else {
        // Exit full screen
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        document.body.style.overflow = 'auto';
        setIsFullScreen(false);
    }

};

const Header = () => {
    const dispatch = useDispatch()
    const open = useSelector((state) => state.header.open);
    const [theme, setTheme] = useState(GetSession('localStorage', 'theme'))
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isDropdown, setIsDropdown] = useState(false)
    const userType = GetSession('cookies', 'loginUserType');
    const user = GetSession('cookies', 'user'); 
    const navigate = useNavigate()

    const data = CommonApiData()
    const Logout = async () => {
        await SetSession('cookies', 'token', 'EXPIRED')
        let user = GetSession('cookies', 'user')
        await SetSession('cookies', 'user', { ...user, loginSessionID: 'EXPIRED' })
        await RemoveSession('cookies', 'BranchCodeCookie')
        await RemoveSession('cookies', 'token')
        if (userType.toUpperCase().trim() === 'ADMIN') {
            navigate('/Admin');
        }
        else {
             navigate('/Logout');
            
        }
    };
    
    useEffect(() => {
        document.body.classList.add('light');
    }, []);

    useEffect(() => {
        if (document && document.body) {
            document.body.classList.remove('light', 'dark');
            if (theme === 'dark') {
                document.body.classList.add('dark');
            } else {
                document.body.classList.add('light');
            }
        }
    }, [theme]);

    useEffect(() => {
        if (!userType || !user)
            NotificationSound('EXPIRED', 'EXPIRED')
    }, [userType, user]);

    return (
        <>
            <nav className={`navbar navbar-expand-lg fixed-top navbar-light main-header p-0`}>
                <div className="container-fluid align-items-center ">
                    <img src={theme === 'light' ? './images/HeaderLogo.jpg' : './images/dark-logo.png'} className={`icon order-2 order-md-1`} alt='CPP logo' />
                    <i onClick={() => dispatch(setOpen(!open))} className="fa-solid fa-bars mx-3 order-1 order-md-2"></i>
                    <ul className="navbar-nav ms-auto d-flex flex-row nav-side-icon align-items-center order-3 order-md-3">
                        <li key='an' className="d-flex align-items-center">
                            {theme === 'light' ?
                                <MdDarkMode
                                    style={{ cursor: 'pointer' }}
                                    title='Dark'
                                    className='fs-3'
                                    onClick={(e) => {
                                        dispatch(setMyStatus(true))
                                        setTheme(theme === 'light' ? 'dark' : 'light')
                                        SetSession('localStorage', 'theme', theme === 'light' ? 'dark' : 'light')
                                    }}
                                /> :
                                <MdLightMode
                                    title='Light'
                                    className='fs-3'
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                        dispatch(setMyStatus(false))
                                        setTheme(theme === 'light' ? 'dark' : 'light')
                                        SetSession('localStorage', 'theme', theme === 'light' ? 'dark' : 'light')
                                    }}
                                />}
                            <div
                                className="nav-item dropdown nav-link dropdown-toggle d-flex align-items-center user_profile"
                                role="button"
                                data-bs-toggle="dropdown"
                                onClick={() => setIsDropdown(!isDropdown)}
                                aria-expanded={isDropdown}
                            >
                                <div className='px-3 py-1 '>
                                    <p className='m-0 fw-bold ' style={{ color: 'var(--text)' }}>
                                        <span className='green_dot'></span>
                                        {data?.UserName} [{data?.UserCode}]
                                    </p>
                                </div>
                                <img
                                    src='./images/user.svg'
                                    alt='user'
                                />
                            </div>
                            <ul className="dropdown-menu dropdown-menu-end p-0">
                                <li key='dealerProfile' className='py-1 border-bottom'>
                                    {userType === "Dealer" &&
                                        <Link className="dropdown-item" style={{ fontSize: '13px', color: 'var(--text)' }} to='/Dealer/DealerProfile'>Dealer Profile</Link>
                                    }
                                    {userType === "Admin" &&
                                        <Link className="dropdown-item" style={{ fontSize: '13px', color: 'var(--text)' }} to='/User/UserProfile'>User Profile</Link>
                                    }
                                </li>
                                {userType === "Admin" &&
                                    <li key='changePassword' className='py-1 border-bottom'>
                                        <Link className="dropdown-item" style={{ fontSize: '13px', color: 'var(--text)' }} to='/User/ChangePassword'>Change Password</Link>
                                    </li>
                                }
                                <li key='logout'>
                                    <button className="dropdown-item" style={{ fontSize: '13px', color: 'var(--text)' }} onClick={Logout}>Logout</button>
                                </li>
                            </ul>
                        </li>
                        <li className='d-none d-md-block'>
                            <span
                                style={{
                                    color: 'var(--blue)',
                                    fontSize: '25px',
                                    cursor: 'pointer'
                                }}
                                title='Full Screen'
                                onClick={(event) => toggleFullScreen(event, '', setIsFullScreen, isFullScreen)}
                            >
                                {!isFullScreen ? <AiOutlineFullscreen /> : <AiOutlineFullscreenExit />}
                            </span>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    )
}
export default Header;